app.component("websiteNavBar", {
	templateUrl: "app/src/website/websiteNavBar.html",
	controller: "websiteNavBarController"
});

app.controller("websiteNavBarController", [
	"$scope",
	"$state",
	"$uibModal",
	function ($scope, $state, $uibModal) {
		$scope.controllerName = "websiteNavBarController";

		$scope.goToFeatures = function () {
			$state.go("features");
		};

		$scope.goToPricing = function () {
			$state.go("pricing");
		};

		$scope.goToAboutUs = function () {
			$state.go("about-us");
        };

        $scope.goToAiTerms = function () {
            $state.go("ai-terms");
        };

        $scope.openDemoModal = function (planName) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/src/website/book-demo.modal.html',
                controller: 'bookDemoController',
                backdropClass: 'modern-modal-backdrop',
                windowClass: 'modern-modal-window',
                size: 'md',
                resolve: {
                    selectedPlan: function () {
                        return planName;
                    }
                }
            });

            modalInstance.result.then(function (result) {
                console.log('Modal closed with result:', result);
            }, function (reason) {
                console.log('Modal dismissed:', reason);
            });
        };
	}
]);